import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  { 
    path: '', 
    loadChildren: () => import('./features/auto-registration/auto-registration.module').then(m => m.AutoRegistrationModule) 
  },
  { 
    path: 'details', 
    loadChildren: () => import('./features/business-details/business-details.module').then(m => m.BusinessDetailsModule) 
  },
  { 
    path: '**', 
    redirectTo: '' 
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
